import { ActionTree, GetterTree, MutationTree } from 'vuex'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import { IUserProfile } from './model'
import { IRootState } from '@/store/model'

const states: IUserProfile = {
  employment: null as any,
  building: null as any
}

const mutations: MutationTree<IUserProfile> = {
  SET_USER_EMPLOYMENT: (state, data) => {
    state.employment = data
  },
  SET_USER_BUILDING: (state, data) => {
    state.building = data
  }
}

const actions: ActionTree<IUserProfile, IRootState> = {
  setUserEmployment: async ({ commit }, data) => {
    commit('SET_USER_EMPLOYMENT', data)
  },
  setUserBuilding: async ({ commit }, data) => {
    console.log('data', data)
    commit('SET_USER_BUILDING', data)
  },
  fetchUserEmploymentAndBuilding: async ({ commit }) => {
    const employeeEndpoint = 'talent/v1/employees'
    const employmentEndpoint = 'talent/v1/employments'
    const buildingEndpoint = 'talent/v1/buildings'
    const uid = encryptDecriptMethods.decrypt(localStorage.getItem('ud'))
    const responseEmployee = await apiOpenUseCase.get(`${employeeEndpoint}?authUserId=${uid}`)
    console.log('length', responseEmployee.result?.data.length)
    if (responseEmployee.result?.data.length > 0) {
      if (responseEmployee.result?.data[0]?.latestEmployment) {
        const userEmployment = responseEmployee.result?.data[0]?.latestEmployment
        if (userEmployment) {
          const employmentId = userEmployment.id
          const responseEmployment = await apiOpenUseCase.get(`${employmentEndpoint}/${employmentId}`)
          if (responseEmployment.result) {
            commit('SET_USER_EMPLOYMENT', responseEmployment.result)
            const buildingId = responseEmployment.result.buildingId
            const buildingName = responseEmployment.result.buildingName
            const building = { id: buildingId, name: buildingName }
            commit('SET_USER_BUILDING', building)
            return building
          }
        }
      }
    }
    return null
  }
}

const getters: GetterTree<IUserProfile, IRootState> = {
  getUserEmployment(state) {
    return state.employment
  },
  getUserBuilding(state) {
    return state.building
  },
}

export default {
  namespaced: true,
  state: states,
  mutations,
  actions,
  getters
}